var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"url_text"},[_c('a',{attrs:{"href":"https://yuankongit.cn/release/release/Agent.zip"}},[_vm._v("点击下载")])])])
}]

export { render, staticRenderFns }